import Cookies from 'js-cookie';
import toast from "react-hot-toast";
import { axiosInstance } from '../lib/axios';
//getanalyticsFunction
const analyticsFunction = async () => {
    try {
        const token = Cookies.get("accessToken");
        const res = await axiosInstance.get(
            `/analytics`,
            {
                headers: { Authorization: `Bearer ${token}` },
            }
        );
        return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};

export {
    analyticsFunction
}
